// extracted by mini-css-extract-plugin
module.exports = {"AboutRole":"_3D8moZgA","AboutContent":"Cle6sfGo","BottomContent":"_3-cDsxoi","OteContent":"_11emnfsU","LeftContent":"kT3GzgWU"};
    if(module.hot) {
      // 1746735887568
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  